export default class Translation {

    static #projects = window.json_projects;
    static #translationObject = window.translation;
    static #selectedLanguage = window.selected_lang; //language set on creator_clients
    static #interfaceLanguage = window.interfaceLanguage; //language of site (murrano.pl, murrano.de...)

    static main(){
        this.#getTextFromProjects();
    }

    static #getTextFromProjects(){
        let object = {};
        for(let projectKey in this.#projects){
            object[projectKey] = {};
            object[projectKey].tabName = this.#projects[projectKey].tab_name;
        }
        this.#translationObject.projects = object;
    }

    static getTranslation(translationKey){
        return (translationKey in this.#translationObject) ? this.#translationObject[translationKey] : '';
    }

    static getSelectedLanguage(){
        return this.#selectedLanguage;
    }

    static getInterfaceLanguage(){
        return this.#interfaceLanguage;
    }
}

Translation.main();
